import { AxiosError } from "axios";
import { FormEvent, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from "../../hooks/useToast";
import { resetPassword } from "../../api";
import TextInput from "../../components/TextInput";
import AuthLayout from "../../layout/AuthLayout";
import Button from "../../components/Button";

export default function ResetPasswordPage() {
  const { toast } = useToast();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [isLoading, setLoading] = useState(false);
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const navigate = useNavigate();

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    try {
      if (!token) {
        toast({
          message: "Este link de recuperação é inválido ou já expirou.",
          type: "error",
        });
        return;
      }
      if (password !== confirmPassword) {
        toast({
          message: "As senhas não coincidem. Digite a mesma senha nos dois campos.",
          type: "error",
        });
        return;
      }
      setLoading(true);
      await resetPassword(password, token);
      toast({
        message: "Senha alterada com sucesso",
        type: "success",
      });
      setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (error) {
      let errorMessage =
        "Não foi possível alterar a senha. Solicite um novo link de recuperação.";
      if (error instanceof AxiosError) {
        const serverError = error.response?.data;
        if (serverError && serverError.error && serverError.message) {
          errorMessage = serverError.message;
        }
      }
      toast({
        message: errorMessage,
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Definir nova senha"
      subtitle="Escolha uma senha nova para voltar a acessar sua conta."
      homeLink
    >
      <form className="flex flex-col gap-4" onSubmit={submit}>
        <TextInput
          id="password"
          name="password"
          type="password"
          autoComplete="new-password"
          variant="outlined"
          label="Nova senha"
          placeholder="Nova senha…"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <TextInput
          id="confirm-password"
          name="confirm-password"
          type="password"
          autoComplete="new-password"
          variant="outlined"
          label="Confirmar senha"
          placeholder="Repita a nova senha…"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        <Button type="submit" disabled={isLoading}>
          {isLoading ? "Salvando…" : "Salvar senha"}
        </Button>
      </form>
    </AuthLayout>
  );
}
